/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMatrixCareHomeHealthAdmissionResponse
 */
export interface CreateMatrixCareHomeHealthAdmissionResponse {
    /**
     * MatrixCare `PatientId` the new admission belongs to.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionResponse
     */
    patient_id: string;
    /**
     * MatrixCare admission UUID of the admission that was created.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionResponse
     */
    admission_id: string;
    /**
     * The committed `external_ehr_patient_admissions` row.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionResponse
     */
    id: string;
}

/**
 * Check if a given object implements the CreateMatrixCareHomeHealthAdmissionResponse interface.
 */
export function instanceOfCreateMatrixCareHomeHealthAdmissionResponse(value: object): value is CreateMatrixCareHomeHealthAdmissionResponse {
    if (!('patient_id' in value) || value['patient_id'] === undefined) return false;
    if (!('admission_id' in value) || value['admission_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateMatrixCareHomeHealthAdmissionResponseFromJSON(json: any): CreateMatrixCareHomeHealthAdmissionResponse {
    return CreateMatrixCareHomeHealthAdmissionResponseFromJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCareHomeHealthAdmissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
        'admission_id': json['admission_id'],
        'id': json['id'],
    };
}

export function CreateMatrixCareHomeHealthAdmissionResponseToJSON(json: any): CreateMatrixCareHomeHealthAdmissionResponse {
    return CreateMatrixCareHomeHealthAdmissionResponseToJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmissionResponseToJSONTyped(value?: CreateMatrixCareHomeHealthAdmissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'admission_id': value['admission_id'],
        'id': value['id'],
    };
}

